import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import {cryptoJs} from '@deanwu/vue-component-library'

Vue.use(Vuex);

let app = new Vue();
export default new Vuex.Store({
	state: {
		session: '',
		userInfo: {},
		authList: [],  // 权限
		navList: [],  // 导航菜单
		systemConfig: {},
		
		dict: {
			productState: {
				0: '草稿',
				1: '下架',
				2: '上架'
			},
			productStateCheck: [{
				name: '草稿',
				value: 0
			}, {
				name: '上架',
				value: 2
			}, {
				name: '下架',
				value: 1
			}],
			couponType: {
				1: '无门槛券',
				2: '满减券',
				3: '满减叠加券'
			},
			
			couponRange: {
				1: '全部商品',
				2: '指定商品',
				3: '指定条件'
			}
		}
	},

	getters: {
		// 判断是否有功能权限
		power(state) {
			return node => {
				return !node || state.authList.includes(node);
			}
		}
	},

	mutations: {
		setSession(state, data) {
			state.session = data;
		},
		
		// 设置用户信息
		setUserInfo(state, data) {
			state.userInfo = data;
		},
		
		// 设置权限列表
		setAuth(state, data) {
			state.authList = data;
		},
		
		// 设置导航菜单
		setNav(state, data) {
			data.unshift({
				id: 1,
				menu_name: '工作台',
				menu_unique_key: 'home',
				menu_ico: 'tf-nav-home'
			});
			state.navList = data;
		},
		
		// 设置系统配置
		setSystemConfig(state, data) {
			state.systemConfig = data;
		}
	},

	actions: {
		// 获取权限列表
		getPowers(store) {
			app.request({
				url: '/store/Custserve/getAuthNode',
				success(data) {
					store.commit('setPowers', data.auth_node);
				}
			});
		},
		
		// 获取系统配置
		getSystemConfig(store) {
			app.request({
				url: '/sys/config',
				data: {
					config_group: 'SCS'
				},
				success(data) {
					store.commit('setSystemConfig', data);
				}
			});
		}
	},

	plugins: [createPersistedState({
		key: 'session',
		paths: ['session', 'userInfo', 'navList', 'authList', 'systemConfig'],
		storage: {
			getItem(key) {
				try {
					return JSON.parse(cryptoJs.AES.decrypt(localStorage.getItem(key), 'session').toString(cryptoJs.enc.Utf8));
				} catch(e) {
					return undefined;
				}
			},
			
			setItem(key, val) {
				localStorage.setItem(key, cryptoJs.AES.encrypt(JSON.stringify(val), 'session').toString());
			},
			
			removeItem(key) {
				localStorage.removeItem(key);
			}
		}
	})]
});
